// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__33rIu","name":"Header_name__2evR0","birthday":"Header_birthday__3vxxF","skeleton":"Header_skeleton__ogaZy"};